import React, { useState, useEffect } from 'react';

const ContactUs = ({ apiClient }) => {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    try {
      const response = await apiClient.get('/contact-info');
      setContactInfo(response.data);
    } catch (error) {
      console.error('Error fetching contact info:', error);
      setContactInfo({
        support_available: false,
        error: 'Unable to load contact information'
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 animate-fade-in">
        <div className="animate-pulse">
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-size-200 animate-shimmer rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-size-200 animate-shimmer rounded w-3/4"></div>
        </div>
      </div>
    );
  }

  if (!contactInfo?.support_available) {
    return (
      <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
        <div className="flex items-center space-x-2">
          <span className="text-gray-400">📞</span>
          <h3 className="text-sm font-semibold text-gray-600">Contact Support</h3>
        </div>
        <p className="text-xs text-gray-500 mt-2">
          {contactInfo?.message || 'Support contact information is being configured.'}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-testid="contact-us-section">
      <div className="flex items-center space-x-2 mb-3">
        <span className="text-blue-600">📞</span>
        <h3 className="text-sm font-semibold text-gray-800">Contact Support</h3>
      </div>
      
      <div className="space-y-2">
        {contactInfo.contact_email && (
          <div className="flex items-center space-x-2">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <a 
              href={`mailto:${contactInfo.contact_email}`}
              className="text-xs text-blue-600 hover:text-blue-800 transition-colors"
              data-testid="contact-email"
            >
              {contactInfo.contact_email}
            </a>
          </div>
        )}
        
        {contactInfo.contact_phone && (
          <div className="flex items-center space-x-2">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <a 
              href={`tel:${contactInfo.contact_phone}`}
              className="text-xs text-blue-600 hover:text-blue-800 transition-colors"
              data-testid="contact-phone"
            >
              {contactInfo.contact_phone}
            </a>
          </div>
        )}
        
        {!contactInfo.contact_email && !contactInfo.contact_phone && (
          <p className="text-xs text-gray-500">
            Contact information is being configured by the administrator.
          </p>
        )}
      </div>
      
      <div className="mt-3 pt-3 border-t border-gray-100">
        <p className="text-xs text-gray-500">
          Need help setting up your restaurant? Get in touch with our support team.
        </p>
      </div>
    </div>
  );
};

export default ContactUs;